var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"text-left font-weight-bold"},[_vm._v(_vm._s(_vm.title))]),_c('td',{attrs:{"colspan":"2"}}),_c('td',{staticClass:"text-right font-weight-bold"},[_vm._v(_vm._s(_vm.montant))])])}
var staticRenderFns = []

export { render, staticRenderFns }